/**
 * @vuelto-surface
 * mobile: inherit
 * desktop: inherit
 * strategy: inherit
 */
import { useEffect, useState } from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors'
import { typography } from '../../../shared/theme/typography';

const STALE_TAB_MS = 12 * 60 * 60 * 1000;

/** Pestaña web abierta muchas horas: recarga voluntaria, no fuerza F5. */
export function WebStaleTabBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    const boot = performance.timeOrigin;
    const check = () => {
      if (document.visibilityState !== 'visible') return;
      setVisible(Date.now() - boot >= STALE_TAB_MS);
    };
    check();
    document.addEventListener('visibilitychange', check);
    const timer = setInterval(check, 15 * 60 * 1000);
    return () => {
      document.removeEventListener('visibilitychange', check);
      clearInterval(timer);
    };
  }, []);

  if (!visible) return null;

  return (
    <View style={styles.wrap} accessibilityRole="alert">
      <Text style={styles.text}>Llevás un rato con esta pestaña. Recargá cuando puedas.</Text>
      <TouchableOpacity
        onPress={() => {
          if (typeof window !== 'undefined') window.location.reload();
        }}
        style={styles.action}
        accessibilityRole="button"
        accessibilityLabel="Recargar"
      >
        <Text style={styles.actionText}>Recargar</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: ticketColors.paper,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  text: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
    fontFamily: ticketFonts.sans,
  },
  action: {
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
  },
  actionText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    fontWeight: '600',
  },
});
